import { useSelector } from 'react-redux';
import { requestSelectors } from 'src/store/requests/selectors';
import { useCallback, useMemo } from 'react';
import { TypeOfRole } from 'src/typings/user';

export const useUser = () => {
  const user = useSelector(requestSelectors.user.getUserData);
  const isRoleEqualTo = useCallback((role: TypeOfRole) => user?.role?.name === role, [user]);
  const isRootadmin = useMemo(() => isRoleEqualTo(TypeOfRole.rootadmin), [user]);
  const isSuperadmin = useMemo(() => isRoleEqualTo(TypeOfRole.superadmin), [user]);
  const isAdmin = useMemo(() => isRoleEqualTo(TypeOfRole.admin), [user]);
  const isPartner = useMemo(() => isRoleEqualTo(TypeOfRole.partner), [user]);
  const isSupervisor = useMemo(() => isRoleEqualTo(TypeOfRole.supervisor), [user]);
  const isManager = useMemo(() => isRoleEqualTo(TypeOfRole.manager), [user]);
  const currentUserRole = useMemo(() => {
    return user?.role?.name;
  }, [user]);
  const getEditRoles = (): TypeOfRole[] => {
    if (isRootadmin) {
      return [TypeOfRole.rootadmin, TypeOfRole.superadmin, TypeOfRole.admin, TypeOfRole.partner, TypeOfRole.supervisor, TypeOfRole.manager];
    } if (isSuperadmin) {
      return [TypeOfRole.admin, TypeOfRole.partner, TypeOfRole.supervisor, TypeOfRole.manager];
    } if (isAdmin) {
      return [TypeOfRole.partner, TypeOfRole.supervisor, TypeOfRole.manager];
    } if (isPartner) {
      return [TypeOfRole.supervisor, TypeOfRole.manager];
    } if (isSupervisor) {
      return [TypeOfRole.manager];
    } if (isManager) {
      return [];
    }
    return [];
  };
  return {
    user,
    currentUserRole,
    isRootadmin,
    isSuperadmin,
    isAdmin,
    isPartner,
    isSupervisor,
    isManager,
    getEditRoles,
  };
};
